import { observer } from 'mobx-react-lite'
import { Trans } from '@lingui/react/macro'

import { hasAccessibilityStatement } from '@jotta/config/hasAccessibilityStatement'
import { useBrandingInfo } from '@jotta/grpc-connect-client/config'
import { cn } from '@jotta/utils/css'

import { CookieLinks } from '../../CookieConsent/CookieLinks'
import { useBrandCode } from '../../hooks/useBrandTheme'

export const PublicFooter = observer(function PublicFooter({
  className,
  currentColor,
}: {
  className?: string
  currentColor?: boolean
}) {
  const brandCode = useBrandCode()
  const {
    brandName,
    aboutUsLink,
    downloadPageLink,
    blogLink,
    termsLink,
    privacyLink,
    supportLink,
  } = useBrandingInfo()
  const showElkjopFooterText = [
    'ELKJOP',
    'ELGIGANTEN',
    'ELKO',
    'GIGANTTI',
  ].includes(brandCode)

  const linkClass = cn('link', {
    'text-current': currentColor,
  })

  return (
    <footer className={cn('py-16', className)}>
      <div className="flex flex-col items-center justify-center gap-4 text-nowrap lg:flex-row">
        <a className={linkClass} href={supportLink}>
          <Trans>Help</Trans>
        </a>

        {aboutUsLink && (
          <a className={linkClass} href={aboutUsLink}>
            <Trans>About us</Trans>
          </a>
        )}

        <a className={linkClass} href={downloadPageLink || '/download'}>
          <Trans>Download</Trans>
        </a>

        {blogLink && (
          <a className={linkClass} href={blogLink}>
            <Trans>Blog</Trans>
          </a>
        )}

        {termsLink && (
          <a className={linkClass} href={termsLink}>
            <Trans>Terms &amp; Conditions</Trans>
          </a>
        )}

        {privacyLink && (
          <a className={linkClass} href={privacyLink}>
            <Trans>Privacy</Trans>
          </a>
        )}

        {hasAccessibilityStatement(brandCode) && (
          <a className={linkClass} href="/accessibility">
            <Trans>Accessibility</Trans>
          </a>
        )}

        <CookieLinks className={linkClass} />
      </div>

      {showElkjopFooterText && (
        <p className="mx-auto max-w-4xl p-8 text-center">
          <Trans>
            {brandName} is a cloud storage service that lets you backup,
            synchronize, store and share files from all your devices. The
            uploaded data is protected by one of the worlds strongest privacy
            laws, with all your data stored the Nordics.
          </Trans>
        </p>
      )}
    </footer>
  )
})
